// removed by extract-text-webpack-plugin
module.exports = {"component":"_10ucv2Zb25jES1_1wPXGGY","js_ul":"_309aJNyL8vW4W2tmJerx_7","js_li":"_1rVAfA5MRJF74B3Ym51HC4","border":"Yz0DC6vmnQvWRJ3cW-JaA","js_all_sou":"O-hG8L5zsQCxCtHgm9Rbv","input":"_3O3EqRr2psSuZ-OpTYwk1O","img":"m47aW9mU6YUWqnF2Xhm6L","selt":"vZyjpZ8F_59uQuGj31h30","bk_zs_link":"_3DR81WrHC2URDbh8MbT75a","allTable":"_28cz33fg3idfmDwGAmL9ng","quanxuan":"_2iffSrE7F0w-nX4q7AmbVC","rightBtn":"_1OQEkdECJjD8FpcsqyCXEk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CrowdfundingMessage/CrowdfundingMessage.scss
 ** module id = 1057
 ** module chunks = 0
 **/